import { render, staticRenderFns } from "./PhotoCanvas.vue?vue&type=template&id=6b9001ae&"
import script from "./PhotoCanvas.vue?vue&type=script&lang=ts&"
export * from "./PhotoCanvas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports